import React, { useEffect, useState } from 'react';
import { handleCallback } from '../auth/cognito.js';
import Spinner from '../components/Spinner.jsx';

export default function AuthCallbackView({ navigate }) {
  const [error, setError] = useState(null);

  useEffect(() => {
    const code = new URLSearchParams(window.location.search).get('code');
    if (!code) {
      setError('No authorization code found in URL.');
      return;
    }
    handleCallback(code)
      .then(() => navigate('/'))
      .catch((e) => setError(e.message));
  }, [navigate]);

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center py-16">
        <div className="bg-red-50 border border-red-200 text-red-800 rounded-lg px-6 py-4 text-sm max-w-sm w-full text-center">
          <p className="font-semibold mb-1">Authentication Failed</p>
          <p>{error}</p>
          <button
            onClick={() => navigate('/')}
            className="mt-3 text-blue-700 hover:underline text-xs"
          >
            Go to home
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center py-16 gap-3">
      <Spinner size="lg" label="Completing sign in…" />
      <p className="text-gray-500 text-sm">Completing sign in…</p>
    </div>
  );
}
